export enum ExchangeRateSourceType {
  Nbp = 0,
  QuarterWge = 1,
  Ecb = 2,
}
